module.exports = __webpack_public_path__ + "static/media/rooms-combo-2.b72db472.png";